import { RiSearchLine, RiSparkling2Line } from "react-icons/ri";
import MemoryButton from "./MemoryButton";
import css from "./memory.module.scss";

export default function MemoryEmpty({ query, onClearSearch }) {
  return (
    <div className={css.shell}>
      <div className={`${css.core} ${css.emptyCore}`}>
        <span className={css.emptyGlyph}>
          {query ? (
            <RiSearchLine aria-hidden="true" />
          ) : (
            <RiSparkling2Line aria-hidden="true" />
          )}
        </span>
        {query ? (
          <>
            <p className={css.emptyTitle}>No memories match</p>
            <p className={css.emptyBody}>
              Nothing saved contains {`"${query}"`}. Try another word.
            </p>
            <MemoryButton variant="ghost" onClick={onClearSearch}>
              Clear search
            </MemoryButton>
          </>
        ) : (
          <>
            <p className={css.emptyTitle}>Nothing remembered yet</p>
            <p className={css.emptyBody}>
              No memories yet. Useful facts will appear here as we work
              together.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
